export enum Status {
    Success = 'Success',
    Error = 'Error',
  }
  
  export const isSuccess = (status: Status) => status === Status.Success;
  export const isError = (status: Status) => status === Status.Error;